import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import { ArrowLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import PageSection from '../PageSections/PageSection';
import * as styles from './ProgramContentCard.module.scss';

const ProgramContentCard = ({ section, imageSide }) => {
  const bgStyles = {
    '--bg-image': `url(${section.backgroundImage?.file?.url})`,
  };
  return (
    <PageSection wide noPad data-analytics-component={'program-content-card'} data-analytics-id={section.title}>
      <div className={styles.grid}>
        <div style={bgStyles} className={[styles['image' + imageSide], styles.imageGrid].join(' ')}>
          <div className={styles.background} style={bgStyles} />
          <div className={styles.mainImageContainer}>
            <ContentfulImage
              objectFit={'contain'}
              className={[styles['image' + imageSide], styles.programImage].join(' ')}
              imageFragment={section.mainImage}
            />
          </div>
        </div>
        <div className={[styles['copy' + imageSide], styles.padAdjust].join(' ')}>
          {section.title && <h3>{section.title}</h3>}
          <RichTextConverter copy={section.copy} />

          {section.ctaLabel && (
            <ArrowLink
              label={section.ctaLabel}
              url={section.ctaUrl}
              isExternal={section.newWindow}
              isDownload={section.ctaIsDownload}
            />
          )}
        </div>
      </div>
    </PageSection>
  );
};

ProgramContentCard.propTypes = {
  section: PropTypes.object,
};
export default ProgramContentCard;
